import Grid from '@mui/material/Grid';
import { errorMessage } from 'constants/CommonConstants';
import { formRequiredRules } from 'helper';
import useProveOtpNew from 'hooks/useProveOtpNew';
import React, { useEffect, useImperativeHandle, useState } from 'react';
import ReactDOM from 'react-dom';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { StepperFromProps } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';
import { CommonButton } from 'sharedComponents/index';
import { CommonNumberInput } from 'sharedComponents/inputGroup/CommonNumberInput';
import { RootState } from 'store/store';

const VerifyOtp: React.ForwardRefRenderFunction<unknown, StepperFromProps> = ({ onNext, onBack }, ref) => {
  // Hooks
  const { t } = useTranslation();
  const isMobile = true;
  const [resendDisabled, setResendDisabled] = React.useState(false);
  const [timer, setTimer] = React.useState(30);
  const hasCalledNextStep = React.useRef(false);
  const hasCalledMounted = React.useRef(false);

  // const target = document.querySelector('.dy-stepper-form__footer__actions');

  // Redux
  const { leadCreationFormData } = useSelector((state: RootState) => state.leadCreationStore);

  const { startProveVerification, otpActions, validationError, otpSent, ERROR_CODES } = useProveOtpNew();

  // React Hook Form
  const { control, trigger, setError, getValues } = useFormContext();
  const phone = getValues('phone');

  // React Hook Form Trigger

  const [target, setTarget] = useState(null);

  useEffect(() => {
    // Look for the footer container
    const el = document.querySelector('.dy-stepper-form__footer__actions');
    if (el) setTarget(el);
  }, []);

  const proveVerification = (phoneNumber: string) => {
    console.log('proveVerification called with phoneNumber:', phoneNumber);
    console.log('leadCreationFormData:', leadCreationFormData);
    startProveVerification(isMobile, leadCreationFormData?.data, phoneNumber, () => {
      console.log('Prove verification started successfully');
      // onNext?.(); // Call the next step function in the parent
    }).catch((error) => {
      console.error('Error in proveVerification:', error?.message);
      hasCalledMounted.current = false;
      console.error('Error in startProveVerification:', error?.message);

      setError('otp', {
        type: 'manual',
        message: t('stepperForm.invalidOtp'),
      });
      trigger('otp'); // Trigger validation for the OTP field
    });
  };

  useEffect(() => {
    if (hasCalledMounted.current) return;
    hasCalledMounted.current = true;

    proveVerification(phone);
  }, []);

  useEffect(() => {
    if (validationError) {
      hasCalledNextStep.current = false;
      if (validationError != ERROR_CODES.AUTH_TOKEN_MISSING) {
        proveVerification(phone);
      }

      if (otpSent) {
        setError('otp', {
          type: 'manual',
          message: t('stepperForm.invalidOtp'),
        });
      }

      // Display the error message to the user as needed
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validationError]);

  const handleResendClick = async () => {
    proveVerification(phone);

    // Simulate sending a new OTP (you should replace this with your actual logic)

    // Disable the resend button
    setResendDisabled(true);

    // Start a timer for 30 seconds
    let countdown = 30;
    setTimer(countdown);

    const timerInterval = setInterval(() => {
      countdown -= 1;
      setTimer(countdown);

      // Enable the resend button when the timer reaches 0
      if (countdown <= 0) {
        clearInterval(timerInterval);
        setResendDisabled(false);
      }
    }, 1000);
  };

  const verifyOtp = async () => {
    console.log('verifyOtp called');
    if (hasCalledNextStep.current) return;
    hasCalledNextStep.current = true;

    const { otp } = getValues();

    if (otpActions?.submitOtp) {
      otpActions?.submitOtp(otp);
    }
  };

  const buttonPortal = target
    ? ReactDOM.createPortal(
        <CommonButton
          type='button'
          onClick={verifyOtp}
          label={t('stepperForm.submit')}
          variant='outlined'
          minWidth='180px'
          className='back'
        />,
        target
      )
    : null;

  const backStep = () => {
    onBack?.();
  };
  useImperativeHandle(ref, () => ({
    backStep,
  }));

  return (
    <>
      <Grid container justifyContent={{ xs: 'center' }}>
        <Grid item xs={12} lg={8}>
          <h3 className='dy-stepper-form__body__title text-center'>{t('stepperFormTradeIn.mobileVerification')}</h3>

          <Grid container justifyContent={{ xs: 'left', sm: 'center' }} rowSpacing={3} columnSpacing={2}>
            <Grid item sm={9} xs={12}>
              <CommonNumberInput
                name='otp'
                control={control}
                label={t('stepperFormTradeIn.enterCode')}
                placeholder={t('stepperFormTradeIn.enterCode')}
                rules={formRequiredRules(errorMessage(t).verificationCodeRequired)}
                triggerValidationForField={trigger}
                thousandSeparator={false}
              />
            </Grid>
          </Grid>

          <Grid container justifyContent={{ xs: 'left', sm: 'center' }} rowSpacing={3} columnSpacing={2}>
            <Grid item sm={9} xs={12}>
              {resendDisabled && <p className='resend-otp pb-3'> {t('stepperFormTradeIn.resendOtp', { timer })}</p>}
              <div className='form-group'>
                <div className='resend-otp'>
                  {t('stepperFormTradeIn.didntReceiveCode')}
                  <button
                    className='resend-otp__cta'
                    type='button'
                    onClick={handleResendClick}
                    disabled={resendDisabled}
                  >
                    {t('stepperFormTradeIn.resend')}
                  </button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {buttonPortal}
    </>
  );
};

const VerifyOtpStep = React.forwardRef(VerifyOtp);

export default VerifyOtpStep;
